import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import {
  AveragingStateValues,
  BrightnessHistory,
  EnergyHistory,
  StateDataResponse,
} from 'lavva.exalushome/build/js/Services/StatesHistory/StatesHistory';
import { useExalusServicesContext } from '../../../../context/services';

export const useExportData = (channel: IDeviceChannel) => {
  const { historyStatesApi } = useExalusServicesContext();
  const device = channel.GetDevice();
  const channelNumber = channel.Number;

  const exportPressureData = async (data?: StateDataResponse<AveragingStateValues>) => {
    if (!data) return;

    try {
      await historyStatesApi.ExportPressureToCsv(device, channelNumber, data);
    } catch (error) {
      console.error('Failed to export pressure data:', error);
    }
  };

  const exportBrightnessData = async (data?: StateDataResponse<BrightnessHistory>) => {
    if (!data) return;
    try {
      await historyStatesApi.ExportBrightnessToCsv(device, channelNumber, data);
    } catch (error) {
      console.error('Failed to export brightness data:', error);
    }
  };

  const exportHumidityData = async (data?: StateDataResponse<AveragingStateValues>) => {
    if (!data) return;

    try {
      await historyStatesApi.ExportHumidityToCsv(device, channelNumber, data);
    } catch (error) {
      console.error('Failed to export humidity data:', error);
    }
  };

  const exportWindSpeedData = async (data?: StateDataResponse<AveragingStateValues>) => {
    if (!data) return;

    try {
      await historyStatesApi.ExportWindSpeedToCsv(device, channelNumber, data);
    } catch (error) {
      console.error('Failed to export wind speed data:', error);
    }
  };

  const exportTemperatureData = async (data?: StateDataResponse<AveragingStateValues>) => {
    if (!data) return;

    try {
      await historyStatesApi.ExportTemperatureToCsv(device, channelNumber, data);
    } catch (error) {
      console.error('Failed to export temperature data:', error);
    }
  };

  const exportEnergyData = async (data?: StateDataResponse<EnergyHistory>) => {
    if (!data) return;

    try {
      await historyStatesApi.ExportEnergyToCsv(device, channelNumber, data);
    } catch (error) {
      console.error('Failed to export energy data:', error);
    }
  };

  return {
    exportPressureData,
    exportBrightnessData,
    exportHumidityData,
    exportWindSpeedData,
    exportTemperatureData,
    exportEnergyData,
  };
};
